module.exports = __webpack_public_path__ + "img/TipperRoof-Profiles.199b7ef1.jpg";